import { render } from "./AddGroupName.vue?vue&type=template&id=9852072a&scoped=true&ts=true"
import script from "./AddGroupName.vue?vue&type=script&lang=ts"
export * from "./AddGroupName.vue?vue&type=script&lang=ts"

import "./AddGroupName.vue?vue&type=style&index=0&id=9852072a&lang=sass&scoped=true"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9852072a"]])

export default __exports__